import { Badge } from '@/components/ui/badge'
import {
  PROPERTIES_PANEL_REASON_TAG_LABELS,
  type PropertiesPanelReasonTag,
} from '@/lib/panels/properties-panel-applicability'

/** Section-header reason tag — shown next to a section's label whenever its controls don't apply
 *  to the current selection, using the existing badge/tag visual design. The header itself always
 *  stays clickable; this only annotates *why* the controls inside are disabled. Includes
 *  "no selection" — every reason tag lives on the header, none are relocated into section content. */
export function SectionReasonTag({ reason }: { reason: PropertiesPanelReasonTag | null }) {
  if (!reason) return null

  return (
    <Badge
      variant="outline"
      size="sm"
      className="font-normal text-muted-foreground border-muted-foreground/30"
    >
      {PROPERTIES_PANEL_REASON_TAG_LABELS[reason]}
    </Badge>
  )
}
